import 'ol/ol.css';
import {Map, View} from 'ol';
import Layer from 'ol/layer/Layer';
import TileWMS from 'ol/source/TileWMS';
import ImageWMS from 'ol/source/ImageWMS';
import Stamen from 'ol/source/Stamen';
import {fromLonLat} from 'ol/proj';
import {Group as LayerGroup} from 'ol/layer';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import {LineString, Polygon} from 'ol/geom';
import {OSM, Vector as VectorSource} from 'ol/source';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {Image as ImageLayer} from 'ol/layer';
import {getArea, getLength} from 'ol/sphere';
import {unByKey} from 'ol/Observable'
import MousePosition from 'ol/control/MousePosition';
import {createStringXY} from 'ol/coordinate';
import {ScaleLine, defaults as defaultControls} from 'ol/control';
import {platformModifierKeyOnly} from 'ol/events/condition';
import {DragBox, Select} from 'ol/interaction';
import Chart from 'chart.js';
import 'chartjs-plugin-zoom';
import Projection from 'ol/proj/Projection';
import Static from 'ol/source/ImageStatic';
import {getCenter} from 'ol/extent';
import Control from 'ol/control';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
import {transform} from 'ol/proj';

import { SidePanel } from 'ol-side-panel';
import LayerSwitcher from 'ol-layerswitcher';

import { BaseLayerOptions, GroupLayerOptions } from 'ol-layerswitcher';

//import {download} from 'downloadjs';


const serveraddress = "https://geoserver.osupytheas.fr/geoserver/";

const ClosedInfoSize = {width: 160, height: 36};
const DefaultPos = {left: '100px', top: '100px'};
const FloatingZIndex = 1000;

//const cors = require('cors');
/*const express = require('express');
let app = express();
app.use(cors());
app.options('*', cors());*/


//import mapControl from 'ol/Map';
//import LayerSwitcher from 'ol/control';
       //import LayerSwitcher from 'ol-layerswitcher';
//import { mapSwitcherControl} from "./switcherControl";

//console.log(fromLonLat([32, 44]));
//const extent = [fromLonLat([-6,30.1875]), fromLonLat([36.29167,45.97917])];
//const imgExt=[0,0,1024,968];//[0, 0, 700000, 1300000];//[0,0,1024,968];
//const imgExt=[-10,28.1875,38.29167,47.97917];//
//const imgExt=[-6.5,30.7,36.2047,46.2003];
//const imgExt=[-6.4,30.25,36.65,46.7]; //previously
const imgExt=[-6.34,29.98,44.53,46.41];
//const imgExt=[-6.2,30.7,36.2047,46.2003];
const imgExt1=[0,0,921,691]
//const imgSize=[3628,1588];

//const imgSize=[3628,1369];
const imgSize=[3955,1281];
//const imgSize=[12614,4705];
//const imgSize=[3153,1156];
//const imgSize=[1814,794];
//const imgSize=[921,691];
//const imgSize=[1016,380];

/*const imgProj= new Projection({
  code: 'xkcd-image',
  units: 'pixels',
  extent: imgExt,
});*/

/*
proj4.defs(
  'EPSG:27700',
  '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 ' +
    '+x_0=400000 +y_0=-100000 +ellps=airy ' +
    '+towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 ' +
    '+units=m +no_defs'
);*/
proj4.defs(
  'WGS84',
  '+proj=eqc +ellps=WGS84 +a=6378137.0 +lon_0=0.0 +to_meter=111319.4907932736 +vto_meter=1 +no_defs +type=crs'
);
register(proj4);

const imgProj= new Projection({
  projection:'EPSG:4326',//'WGS84',//'EPSG:4326',//'EPSG:27700',
  extent: imgExt,
});

const maltaCoord = [14.35, 35.85];
const maltaProj = fromLonLat(maltaCoord);
//alert(maltaProj);
var legendURL = "https://geoserver.capemalta.net/geoserver/SHAREMED/wms?REQUEST=GetLegendGraphic&VERSION=1.1.1&FORMAT=image/gif&WIDTH=15&HEIGHT=15&LAYER=SHAREMED:%LAYER_INFO%&legend_options=transparent:true;bgColor:0xE0E0E0;dpi:91;Transparent=True;fontAntiAliasing:true;fontName:Arial;fontColor:0x011f4b;dx:0.2;dy:0.2;mx:0.3;my:0.2;"

var base = new TileLayer({
    source: new Stamen({
        layer: 'terrain-background',
    })
});

//alert(base.source.getProjection());

var imgLayer= new ImageLayer({
      source: new Static({
        attributions: '© png',
        //url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/' +
      //'British_National_Grid.svg/2000px-British_National_Grid.svg.png',  //'http://localhost:1234/strange_map.png',//'https://imgs.xkcd.com/comics/online_communities.png', //'http://localhost:1234/imgBlg_20191207_uvvel_0_0.png',
       //url: 'http://localhost:1234/strange_map.png',
	   //url: 'http://localhost:1234/atlas/yearly/2019/yearly_2019_4326.png',
	   url: 'http://10.71.2.53:1234/atlas/monthly/2019/total_monthly_Cat4_12_2019_4326.png',
		crossOrigin:'',
		projection: 'WGS84', //'EPSG:4326',//'EPSG:27700',
		imageSize:imgSize,
        imageExtent: imgExt,//[-6,30.1875,36.29167,45.97917]//imgExt,
      }),
    });
	
var imgView=new View({
    projection:'EPSG:4326',// 'WGS84', //'EPSG:4326',//'EPSG:27700',
    center: maltaCoord,//getCenter(imgExt), //getCenter(imgExt),
    zoom: 5,
   // maxZoom: 8,
  });
	

	


/*var view = new View({
    center: [500,450],//maltaProj,
	//projection: new Projection("EPSG:4326"),
    zoom: 6.75
});
/*
var view = new View({
    projection: projection,
    center: getCenter(extent),
    zoom: 2,
    maxZoom: 8,
});*/

// tO GET MOUSE POSITION AT THE MAP CLICK TO GET TIMESERIES DATA
const mousePositionControl = new MousePosition({
  coordinateFormat: createStringXY(4),
  projection: 'EPSG:4326',
  // comment the following two lines to have the mouse position
  // be placed within the map.
  className: 'custom-mouse-position',
  target: document.getElementById('mouse-position'),
});


/*

                new ol.layer.Group({
                  title: 'SHAREMED Base-Map(CoastLine)',
                  type: 'base',
                  combine: true,
                  visible: false,
                  layers: [
                    new ol.layer.Image({
                      source: new ol.source.ImageWMS({
                        url: serveraddress+'/wms',
                        params: { 'LAYERS': 'Sharemed_D:Ocean_SHAREMED' },
                        ratio: 1,
                        serverType: 'geoserver',
                        attributions: 'Base-Map by SHAREMED',
                      })
                    }),
                    new ol.layer.Image({
                      extent: [-674732.4575111731, 4135977.267073835, 1762262.1796431735, 5666608.452105071],
                      zIndex: 500,
                      source: new ol.source.ImageWMS({
                        url: serveraddress+'/wms',
                        params: { 'LAYERS': 'Sharemed_D:CoastLine', 'STYLES': 'CoastlinePolygon' },
                        ratio: 1,
                        serverType: 'geoserver',
                        
                      })
                    }),
                    new ol.layer.Image({
                      visible: false,
                      extent: [-674732.4575111731, 4135977.267073835, 1762262.1796431735, 5666608.452105071],
                      source: new ol.source.ImageWMS({
                        url: serveraddress+'/wms',
                        params: { 'LAYERS': 'Sharemed_D:Countries Boundries', 'STYLES': 'Borderline Grey' },
                        ratio: 1,
                        serverType: 'geoserver',
                        
                      })
                    })
                  ]
                }),
                
                new ol.layer.Group({
                  title: 'SHAREMED Base-map',
                  type: 'base',
                  combine: true,
                  visible: true,
                  layers: [
                    new ol.layer.Image({
                      title: 'Ocean',
                      visible: true,
                      source: BasemapOceanSource
                    }),
                    new ol.layer.Image({
                      title: 'Base Map 250M',
                      visible: true,
                      source: new ol.source.ImageWMS({
                        url: serveraddress+'/wms',
                        params: { 'LAYERS': 'Sharemed_D:Basemap V1' },
                        ratio: 1,
                        serverType: 'geoserver',
                        attributions: 'Base-Map by SHAREMED',
                      })
                    }),
                    new ol.layer.Image({
                      extent: [-674732.4575111731, 4135977.267073835, 1762262.1796431735, 5666608.452105071],
                      zIndex: 500,
                      source: new ol.source.ImageWMS({
                        url: serveraddress+'/wms',
                        params: { 'LAYERS': 'Sharemed_D:CoastLine' },
                        ratio: 1,
                        serverType: 'geoserver',
                        
                      })
                    }),
                    new ol.layer.Image({
                      extent: [-674732.4575111731, 4135977.267073835, 1762262.1796431735, 5666608.452105071],
                      source: new ol.source.ImageWMS({
                        url: serveraddress+'/wms',
                        params: { 'LAYERS': 'Sharemed_D:Countries Boundries' },
                        ratio: 1,
                        serverType: 'geoserver',
                        
                      })
                    })
                  ]
                }),

                new ol.layer.Group({
                  title: 'Bathymetry (EMODNET)',
                  type: 'base',
                  combine: true,
                  visible: false,
                  layers: [
                    new ol.layer.Image({
                      extent: [-674732.4575111731, 4135977.267073835, 1762262.1796431735, 5666608.452105071],
                      source: new ol.source.ImageWMS({
                        url: 'https://ows.emodnet-bathymetry.eu/wms',
                        params: { 'LAYERS': 'mean_atlas_land' },
                        ratio: 1,
                        serverType: 'geoserver',
                        attributions: 'Terrain Model by EMODNnet'
                      })
                    })
                  ]
                }),

                new ol.layer.Image({
                  extent: [-624019.4601243109, 4163691.1591173103, 1763347.2153563066, 5639470.26589252],
                  title: 'Contours (Sea Depth)',
                  visible: false,
                  zIndex: 500,
                  source: new ol.source.ImageWMS({
                    url: 'https://ows.emodnet-bathymetry.eu/wms',
                    params: { 'LAYERS': 'contours' },
                    ratio: 1,
                    serverType: 'geoserver',
                    attributions: 'Contour Lines by EMODnet'
                  })
                }),

                new ol.layer.Image({
                  title: 'Water Mask',
                  visible: false,
                  source: new ol.source.ImageWMS({
                    url: serveraddress+'/wms',
                    params: { 'LAYERS': 'Sharemed_D:Water Mask' },
                    ratio: 1,
                    serverType: 'geoserver',
                  })
                }),
               
                new ol.layer.Image({
                  title: 'Coastline',
                  visible: false,
                  zIndex: 500,
                  source: new ol.source.ImageWMS({
                    url: serveraddress+'/wms',
                    params: { 'LAYERS': 'Sharemed_D:CoastLine', 'STYLES': 'CoastlineStroke' },
                    ratio: 1,
                    serverType: 'geoserver',
                  })
                }),

                new ol.layer.Tile({
                  extent: [-624019.4601243109, 4163691.1591173103, 1763347.2153563066, 5639470.26589252],
                  title: 'Country Labels',
                  visible: false,
                  zIndex: 500,
                  source: new ol.source.Stamen({
                    layer: 'terrain-labels',
                  })
                }),
              ]
            }),
            new ol.layer.Group({
              title: 'OPERATIONAL DATA',
              fold: 'open',
              layers: [AtmosphericModelling, Modelling,
                new ol.layer.Group({
                  title: 'Satellite data',
                  fold: 'close',
                  layers: list_openlayer_tile.filter(function (item) { return list_var_satellite.includes(item.get(['Name'])) }),
                }),
                new ol.layer.Group({
                  title: 'In situ operational data',
                  fold: 'close',
                  layers: [Vectorstations, VGroup1, VGroup2, VGroup3,
                    new ol.layer.Group({
                      title: 'Radar data',
                      fold: 'close',
                      layers: list_openlayer_tile.filter(function (item) { return list_var_radar.includes(item.get(['Name'])) }),
                    }),
                  ]
                }),
              ]
            })
          ],





*/





var map = new Map({
	controls:defaultControls().extend([mousePositionControl]),
    target: 'map',
 layers: [
	  new LayerGroup
	   ({ title:"<h2>BASE MAP</h2><br>",
	     combine:false,
		 

//////////////////////////////////////////////////	   
	   layers: [
    new TileLayer(
      {	title: "Watercolor",
	  type: 'base',
       baseLayer: true,
	   visible: false,
	   //ratio:1,
       source: new Stamen({
         layer: 'watercolor'
       })
      }),

    new TileLayer(
      {	title: "OSM",
	  //ratio:1,
	  type: 'base',
       baseLayer: true,
       source: new OSM(),
       visible: false
      }),
	  

                    new ImageLayer({
                      //extent: [-674732.4575111731, 4135977.267073835, 1762262.1796431735, 5666608.452105071],
					  title: "EMODNET Bathymetry",
					  baseLayer:true,
					  type: 'base',
					 // ratio:1,
					  visible:false,
                      source: new ImageWMS({
                        url: 'https://ows.emodnet-bathymetry.eu/wms',
                        params: { 'LAYERS': 'mean_atlas_land' },
                        ratio: 1,
                        serverType: 'geoserver',
                        attributions: 'Terrain Model by EMODNnet'
                      })
                    }),

	  
	/*new TileLayer(
      {	title: "Bathymetry (EMODNET)",
       baseLayer: true,
       source: source_emodnet,//new ol.source.OSM(),
       visible: false
      }),*/

     new TileLayer(
	 {
	title: "SHAREMED",
	type: 'base',
	//ratio:1,
     baseLayer: true,	
     source: new Stamen({
        layer: 'terrain-background'
    })
   })  

///]})
	   
//////////////////////////////////////////////////////	   
	   
	   
	  /* 	   new LayerGroup
	   ({ title:"image",
	      layers: [imgLayer]
	   })*/
     ]
})

],	 
	//control: [new mapControl.LayerSwitcher],
    view: new View({
		//center:maltaCoord,//[33,44],
		//center: transform(getCenter(imgExt),'EPSG:27700','EPSG:3857'),
		//center: transform(getCenter(imgExt),'EPSG:4326','EPSG:3857'),
		center: transform(getCenter(imgExt),'WGS84','EPSG:3857'),
		zoom:5.7,
	}),//imgView
});



map.on('click', function (event) {


	  var lonlat = transform(event.coordinate, 'EPSG:3857', 'EPSG:4326');
      var lon = lonlat[0];
      var lat = lonlat[1];
	
	openChartDiv(lat,lon);
	
});


////SIDE PANEL//////////////////////////////////////////////////{
const sidePanel = new SidePanel();

map.addControl(sidePanel);


const layersPane = sidePanel.definePane({	
  paneId: 'layers',
  name: 'SHAREMED ATLAS LAYERS',
  icon: '<i class="fa fa-bars"></i>'
});


const layersPane2 = sidePanel.definePane({
  paneId: 'info',
  name: "SHAREMED INFO",
  icon: '<i class="fa fa-info-circle"></i>'
});

/*
const layersPane3 = sidePanel.definePane({
  paneId: 'link',
 // name: "SHAREMED INFO",
  icon:'<a href="https://github.com/Turbo87/sidebar-v2" role="tab" target="_blank"><i class="fa fa-globe"></i>' //'<i class="fa fa-github"><a href="https://github.com/Turbo87/sidebar-v2" role="tab" target="_blank"></a></i>'
  
  
});*/

const layersGreeting = document.getElementById('sidebar');
layersPane.addWidgetElement(layersGreeting);

const layerInfo=document.createElement("p");
layerInfo.setAttribute("class","text-justify");
layerInfo.innerHTML="<b>SHAREMED</b> focuses on increasing the capabilities to assess and address hazards related to pollution and environmental threats in Mediterranean transnational waters.<br><br><br> This objective will be pursued by sharing knowledge, observation and technologies and building common frameworks, tools and services to assess and possibly forecast impacts of environmental threats, including those of transboundary origin. This will enhance the capability to produce and deliver coherent and jointly produced assessments on important issues like pollution (marine litter), changes in trophic regimes (eutrophication/oligotrophication), weather/climate change (marine heat waves, warming, acidification), as well as increasing the possibility to find, access, and use existing data and information on those issues, serving the needs of national responsible entities, stakeholders and a range of users.";
layersPane2.addWidgetElement(layerInfo);

/*const layerLink=document.createElement("a");
layerLink.setAttribute("href","https://github.com/Turbo87/sidebar-v2");
layerLink.setAttribute("target","_blank");
layersPane3.addWidgetElement(layerLink);*/


////SIDE PANEL//////////////////////////////////////////////////}




/*
const osm = new LayerTile(({
  title: 'OSM',
  type: 'base',
  visible: true,
  source: new SourceOSM()
}) as BaseLayerOptions),

const watercolor = new LayerTile({
  title: 'Water color',
  type: 'base',
  visible: false,
  source: new SourceStamen({
    layer: 'watercolor'
  })
} as BaseLayerOptions);

const baseMaps = new LayerGroup({
  title: 'Base maps',
  layers: [osm, watercolor]
} as GroupLayerOptions); */


/*
const map = new Map({
  target: 'map',
  layers: [baseMaps]
});*/

/*
var BasemapOceanSource = new Source.ImageWMS({
  url: serveraddress+'/wms',
  // refer to the section layer name to find the name of the layer 
  params: { 'LAYERS': 'Sharemed_D:Seabed V1' },
  ratio: 1,
  serverType: 'geoserver',
  tileSize: 1,
}); */


//console.log($("#home_layer_switcher").get(0));
//console.log(layersPane);

///LAYER SWITCHER//////////////////////////////////////////////

const layerSwitcher = new LayerSwitcher({
  //reverse: true,
  //target: $("#sidebar > div ").get(0)
 // target: $("#home_layer_switcher").get(0)
  groupSelectStyle: 'group'
});


  var toc = document.getElementById('home_layer_switcher');
  LayerSwitcher.renderPanel(map, toc, { reverse: true });
 // map.addControl(layerSwitcher);

///LAYER SWITCHER//////////////////////////////////////////////



//layersPane.addWidgetElement(layersGreeting);

//map.addControl(layerSwitcher);
//layersPane.addWidgetElement(layerSwitcher);
//map.addControl(layerSwitcher);
//layersPane.addWidgetElement(layerSwitcher);


//layersPane.addWidgetElement(document.getElementsByClassName("paramSelectDropdown"));

//layersPane.addWidgetElement(layersGreeting);
//console.log(layersPane);



/*
map.addEventListener('onclick', function (event) {
  //mousePositionControl.setProjection(event.target.value);
  alert("coord");
});*/

//map.addControl(new mapSwitcherControl(map));
//map.addControl(new Control.PanZoomBar);


/*var layerSwitch=new LayerSwitcher({
	tipLabel:"legend"
});
map.addControl(layerSwitch);*/


/*
map.addControl(new LayerSwitcher([
{
	layer:'base',
		 config:{
		 title:"base",
		 description:"base",
	 }
},
{
	layer:'imgLayer',
		 config:{
		 title:"imageLayer",
		 description:"imageLayer",
	 }
}

]));*/
//map.addControl(new Control.LayerSwitcher({}));
/*
map.addControl(new LayerSwitcher(
[
{
	 layer: base,
	 config:{
		 title:"base",
		 description:"base",
	 }
}
]
));	 */




//******** GLOBAL VARIABLES *************//

// TEMP
window.layersTemp = [base];
window.layers = [base];
window.layerParams = ["RMS_WaveHeight", "WAM_WaveHeight","SKIRONSWAN_WH"];
window.models = ["", "ROSMariaSWAN", "WAM","SKIRONSWAN"];
window.sliders = ["", "ROSMariaSWAN", "WAM","SKIRONSWAN"];
window.values = ["", "ROSMariaSWAN", "WAM","SKIRONWAN"];
window.legends = ["", "RMS_WaveHeight&STYLE=WH_LYR", "WAM_WaveHeight&STYLE=WAM_WH","RMS_WaveHeight&STYLE=WH_LYR"];
window.dateTemp = ["", "20210517", "20210602","20210519"];
window.units = ["","meters","meters","meters"];
window.monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// find where this can be updated to current hour, in populate layers?
window.sliderTopRange = ["", 24, 8, 24];
window.isLayerSelected = false;
window.selectedId = "";



window.load_atlas_map_monthly_1=function(){
	//alert("try");
}


window.onload = function() {  
	//alert("index.js on load");
	
    registerEvents();
    populateLayers();
    addClassForModelLayers();
    setOptions();
    importScripts(); 
    hideInfo();
    populateInputValuesAndSliders();
};

//$('#atlas_monthly').attr('onclick', 'load_atlas_map_monthly_11()');

//******** FUNCTIONS 


window.load_atlas_map_yearly=function(year,cat)
{

   var layers_grp_yearly = map.getLayerGroup();
   var layers_yearly=map.getLayers();	
   var url_yearly='http://sharemed.ocean.mt/atlas/maps/yearly/'+year+'/yearly'+cat+'_'+year+'_4326.png'
   //alert(url_yearly);

   // $("#map_title").text("Yearly map for "+year+" "+cat);
   //alert(url_yearly);	  

		var imgLayer= new ImageLayer({
      source: new Static({
        attributions: '© png',
	   url: url_yearly, //'http://localhost:1234/atlas/monthly/2019/total_monthly_Cat4_12_2019_4326.png',
		crossOrigin:'',
		projection: 'WGS84', //'EPSG:4326',//'EPSG:27700',
		imageSize:imgSize,
        imageExtent: imgExt,//[-6,30.1875,36.29167,45.97917]//imgExt,
      }),
    });
	
     var imgView=new View({
       projection:'EPSG:4326',// 'WGS84', //'EPSG:4326',//'EPSG:27700',
       //center:getCenter(imgExt), //getCenter(imgExt),
       zoom: 3,
       // maxZoom: 8,
         });

      
	  //var newDiv=
	  
	  

	if(layers_yearly.getArray().length==1)
	{
	   var layerGrp=new LayerGroup({ //title:"image",  //show result image layer without name "image"
	      layers: [imgLayer],
	   });
	  //layerGrp.addLayer(imgLayer);
	  map.addLayer(layerGrp);//addLayer(imgLayer);
	
	   var layerSwitch=new LayerSwitcher({
	   tipLabel:"legend"
       });
      // map.addControl(layerSwitch);		 
	 
	 } //if
	else
    {
	  var layers_grp_yearly = map.getLayerGroup();
	  var layer_rmv=map.getLayers().getArray()[1]; //map.getLayersByName('imgLayer');
	  map.removeLayer(layer_rmv);
	  
	  	   var layerGrp=new LayerGroup({ //title:"image", //show result image layer without name "image"
	      layers: [imgLayer],
	   });
	  //layerGrp.addLayer(imgLayer);
	  map.addLayer(layerGrp);//addLayer(imgLayer);
	
	   var layerSwitch=new LayerSwitcher({
	   tipLabel:"legend"
       });
	   
       //map.addControl(layerSwitch);		
	  



    }		
	  
	  

}



window.load_atlas_map_monthly=function(year,cat,month)
{
	//$('#cat_yearly').selected;
	//alert(year+" "+cat+" "+month);
	//alert('add_atlas_map_monthly');
   var layers_grp_monthly = map.getLayerGroup();
   var layers_monthly=map.getLayers();	
   var url_monthly='https://sharemed.ocean.mt/atlas/maps/monthly/'+year+'/monthly'+cat+'_'+month+'_'+year+'_4326.png'
   
     var mm=$("#month_monthly option:selected").text();
    $("#map_title").text("Monthly map for "+mm+" "+year+" "+cat);   //alert(url_yearly);	  

		var imgLayer= new ImageLayer({
      source: new Static({
        attributions: '© png',
	   url: url_monthly, //'http://localhost:1234/atlas/monthly/2019/total_monthly_Cat4_12_2019_4326.png',
		crossOrigin:'',
		projection: 'WGS84', //'EPSG:4326',//'EPSG:27700',
		imageSize:imgSize,
        imageExtent: imgExt,//[-6,30.1875,36.29167,45.97917]//imgExt,
      }),
    });
	
     var imgView=new View({
       projection:'EPSG:4326',// 'WGS84', //'EPSG:4326',//'EPSG:27700',
       //center:getCenter(imgExt), //getCenter(imgExt),
       zoom: 3,
       // maxZoom: 8,
         });



	if(layers_monthly.getArray().length==1)
	{
	   var layerGrp=new LayerGroup({ title:"image",
	      layers: [imgLayer],
	   });
	  //layerGrp.addLayer(imgLayer);
	  map.addLayer(layerGrp);//addLayer(imgLayer);
	
	   var layerSwitch=new LayerSwitcher({
	   tipLabel:"legend"
       });
       //map.addControl(layerSwitch);		 
	 
	 } //if
	else
    {
	  var layers_grp_monthly = map.getLayerGroup();
	  var layer_rmv=map.getLayers().getArray()[1]; //map.getLayersByName('imgLayer');
	  map.removeLayer(layer_rmv);
	  
	  	   var layerGrp=new LayerGroup({ title:"image",
	      layers: [imgLayer],
	   });
	  //layerGrp.addLayer(imgLayer);
	  map.addLayer(layerGrp);//addLayer(imgLayer);
	
	   var layerSwitch=new LayerSwitcher({
	   tipLabel:"legend"
       });
      // map.addControl(layerSwitch);			  
    }			  
}

//$('#atlas_monthly').attr('onclick', 'load_atlas_map_monthly_1()');
function load_atlas_map_yearly_1()
{
	//alert("add_atlas_map_yearly at atlas_select");
}

//atlas_select

//document.getElementById('atlas_yearly').onclick = load_atlas_map_yearly_1(); 
 //$('atlas_monthly').attr('onclick', 'openAtlasPanel()');
 //$('#atlas_yearly').attr('onclick', load_atlas_map_yearly_1());

/*document.getElementById('atlas_monthly').onclick = function(){
 alert("click on monthly");	
 openAtlasPanel();
 //load_atlas_map_monthly_1()
};*/


/*

function openAtlasPanel()
{
	alert("openAtlasPanel()");
	openAtlasPanel_1();
	buttonDivOK.onclick=load_atlas_map_monthly_1();
	//alert($('#atlas_monthly'));
	
	$('#atlas_monthly').click(function() {
 // alert( "Handler for .click() called." );
   });
	$('#atlas_select_monthly').click(load_atlas_map_monthly_1());
	//document.getElementById('atlas_select_monthly').onclick = load_atlas_map_monthly_1(); 
	//$('#atlas_select_monthly').on('click',load_atlas_map_monthly_1());
}*/


/*
 $('#atlas_monthly').attr('onclick', 'openAtlasPanel()');
 $('#atlas_yearly').attr('onclick', 'load_atlas_map_yearly_1()');*/

/*
function openMap()
{
	alert('add_atlas_map');
	addAtlasMap();
	//var cls = buttonClsList[0];
	var targetID = "ROSMariaSWAN";
	var index = models.indexOf(targetID);
	//var index="ROSMariaSWAN";
    var targetLayer = layers[index];
	var layerGrp=new LayerGroup({ title:"image",
	      layers: [imgLayer],
	   });
	//layerGrp.addLayer(imgLayer);
	map.addLayer(layerGrp);//addLayer(imgLayer);
	
	var layerSwitch=new LayerSwitcher({
	tipLabel:"legend"
});
map.addControl(layerSwitch);



	//map.addLayer(targetLayer);
	
//	map.addControl(new Control.LayerSwitcher({'ascending':false}));
	
	//map.addControl(cntrl.LayerSwitcher());

	//populateLayers();
  //const view = map.getView();
  //const zoom = view.getZoom();
  //view.setZoom(zoom - 1);
};*/

function addAtlasMap()
{
	alert('add map');
/* var layerParamsArray = layerParams;
 for (var i = 0; i < layerParamsArray.length; i++) {
 	var geoserverLayerId = layerParamsArray[i];
 	var sharemedId = 'SHAREMED:' + geoserverLayerId;
 	var newLayer =  new TileLayer({
					    source: new TileWMS({
					        url: 'https://geoserver.capemalta.net/geoserver/SHAREMED/wms',
					        params: {'LAYERS': sharemedId,'Tiled':'TRUE','transparent':'true'},
					        serverType: 'geoserver',
					    crossOrigin: 'anonymous',
				      })});
 	if(newLayer !== null) {
 		layers.push(newLayer);
 	}
 }*/
}


function registerEvents() {

    // EVENT: on click for collapsing/expanding the sidebar chapters
    var paramSelectDropdownEls = document.getElementsByClassName("paramSelectDropdown");
    for (var i = 0; i < paramSelectDropdownEls.length; i++) {
        paramSelectDropdownEls[i].addEventListener('click', (event) => toggleParamSelectDDCollapse(event));
		//layersPane.addWidgetElement(paramSelectDropdownEls);
		
    }
//layersPane.addWidgetElement(paramSelectDropdownEls);
    // EVENT: on click for collapsing/expanding the sidebar chapters
    var subMenuDropdownEls = document.getElementsByClassName("subMenuDropdown");
    for (var i = 0; i < subMenuDropdownEls.length; i++) {
        subMenuDropdownEls[i].addEventListener('click', (event) => toggleSubMenuDDCollapse(event));
    }
	//alert(document.getElementsByClassName("paramSelectDropdown"));
	//alert(layersPane);
	//console.log(layersPane);
	//console.log(layersPane);
	
	//layersPane.addWidgetElement(document.getElementById("sidebar")); //add button selection to moving sidebar
	
	
	//console.log(document.getElementById("sidebar"));
	//console.log(document.getElementById("layer_switcher"));
	
	//layersPane.addWidgetElement(document.getElementById("layer_switcher")); 
	//layersPane.addWidgetElement(subMenuDropdownEls);
	
	
	//var atlasAddButtonClick=document.getElementById("atlas_yearly");
	//alert(atlasAddButtonClick)
	//atlasAddButtonClick.addEventListener('click',openAtlasPanel());

      // EVENT: on singleclick for layers
  map.on('pointermove', function (evt) {
    if (!isLayerSelected) {
      return;
    }

  var viewResolution = (view.getResolution());
  var currentLayer = getCurrentLayer();
  var source = currentLayer.getSource();
  var url = source.getFeatureInfoUrl(
    evt.coordinate,
    viewResolution,
    'EPSG:3857',
    {'INFO_FORMAT': 'application/json'}
  );
  if (url) {
       fetch(url)
      .then(function (response) { 
        var aText = response.text();
        return aText; 
      })
      .then(function (responseText) {
        var index = models.indexOf(selectedId);
        var shownValue = "Selected area is out of bounds";
        var featuresReturned = responseText.substring(responseText.indexOf('['), responseText.lastIndexOf(']') + 1);
        if(featuresReturned !== "[]") {
         var properties = featuresReturned.substring(featuresReturned.indexOf("GRAY_INDEX") + 12);
         var value = properties.replace("}}]", "");
         var layerGroupName = getLayerGroupName();
         if(value === "999" || value === "null") {
         	shownValue = "No data available";
         } else {
         	if(value.length > 10) {
         		shownValue = layerGroupName + ": " + value.substring(0, value.length - 10) + " " + units[index];
         	} else {
         		shownValue = layerGroupName + ": " + value  + " " + units[index];
         	}
         }
        }
        
        showInfo(shownValue);
      });
  }
 });
    // other events, whatever you need can be put here
};





function populateLayers ()
{
//alert('ok');	
 var layerParamsArray = layerParams;
 for (var i = 0; i < layerParamsArray.length; i++) {
 	var geoserverLayerId = layerParamsArray[i];
 	var sharemedId = 'SHAREMED:' + geoserverLayerId;
 	var newLayer =  new TileLayer({
					    source: new TileWMS({
					        url: 'https://geoserver.capemalta.net/geoserver/SHAREMED/wms',
					        params: {'LAYERS': sharemedId,'Tiled':'TRUE','transparent':'true'},
					        serverType: 'geoserver',
					    crossOrigin: 'anonymous',
				      })});
 	if(newLayer !== null) {
 		layers.push(newLayer);
 	}
 }
}

function populateInputValuesAndSliders () 
{
  showSliderInfo(false);

  // registering event on slider and value
    var sliderEl = $(".slider");

  // registering on input event on slider change
    sliderEl[0].oninput = function onSliderChange (event) {
      var index = sliders.indexOf(selectedId);
      var currentLayer = layers[index];
      var valueEl = document.getElementsByClassName("value")[0];
      var dateTimeString = getDateTimeString();
      var isSingleDigit = this.value.length === 1;
      var isAdaptedValueSingleDigit = (this.value - 1 + "").length === 1;
      var hour = isAdaptedValueSingleDigit ? "0" + (this.value - 1) : (this.value - 1);
      if(sliderTopRange[index] === 8) {
        hour = getCalculatedHour(hour);
      }
      valueEl.innerHTML = getDisplayDate() + ": Hour " + [hour];
      // TEMP
      var dimMonthValue = dateTemp[index] + hour;
      //var dimMonthValue = dateTimeString + addedValue; //https://docs.geoserver.org/latest/en/user/rest/imagemosaic.html#updating-an-image-mosaic-contents
      currentLayer.getSource().updateParams({'DIM_MONTH': [dimMonthValue]})
    }
}; 

function getCalculatedHour (hour) {
  switch(hour)
        {
            case "00":
                return "00";
                break;
            case "01":
                return "03";
                break;
            case "02":
                return "06";
                break;
            case "03":
                return "09";
                break;
            case "04":
                return "12";
                break;
            case "05":
                return "15";
                break;
            case "06":
                return "18";
                break;
            case "07":
                return "21";
                break;               
            default:
                return "00";
        }
}

function getDisplayDate ()
{
  // TEMP
  var index = models.indexOf(selectedId);
  var stringDate = dateTemp[index];
  var year = stringDate.substring(0, 4);
  var month = stringDate.substring(4, 6);
  if(month[0] === "0") {
    month = month[1];
  }
  var displayMonth = monthName[month-1];
  var day = stringDate.substring(6);

  return day  + " " + displayMonth + " " + year;
  /*
  var date = new Date();
  var day = date.getUTCDate().length === 1 ? "0" + date.getUTCDate() : date.getUTCDate();
  var month = monthName[date.getMonth()];
  var year = date.getFullYear();
  return day  + " " + month + " " + year;
  */
}

function getCurrentLayer() {
  var currentID = models.indexOf(selectedId);
  var currentLayer = layers[currentID];
  return currentLayer;
};

function getDateTimeString () {
  var currentTime = new Date();
  var year = currentTime.getFullYear().toString();
  var month = currentTime.getMonth().toString();
  if(month.length === 1)
    {
     month = "0" + month;
    }
  var day = currentTime.getUTCDate().toString();
  if(day.length === 1)
    {
     day = "0" + day;
    }
  return year + month + day;  
}

function addClassForModelLayers() {
  var modelLayerEls = $(".modelLayer");
  for (var i = 0; i < modelLayerEls.length; i++) {
  	var modelLayerButton = modelLayerEls[i];
  	var buttonText = modelLayerButton.textContent || modelLayerButton.innerText;
  	modelLayerButton.classList.add(buttonText.replace(" ", ""));
  	modelLayerButton.onclick = showModelLayer; 
  }
}

function getLayerGroupName ()
{
  var index = selectedId;
  if(selectedId === "") 
  {
    return "";
  }
  var layerElement = document.getElementsByClassName(selectedId)[0];
  var groupID = layerElement.getAttribute("id");
  var groupName = groupID[0].toUpperCase() + groupID.substring(1);
  return groupName;
}

function showModelLayer (event) {
	alert(event);
	var buttonClsList = event.target.classList;
	alert(buttonClsList)
	var targetID = getIDFromButton(buttonClsList);
	if(targetID === "")
	{
	   console.log("Couldn't find relevant class for button with classes: " + buttonClsList)
	   return;
	}
	if(targetID === selectedId) {
		deselectCurrentLayer();
		return;
	}
	if(isLayerSelected) {
		deselectCurrentLayer();
	}
	selectLayer(targetID);
  showLegend();
}

function showLegend ()
{
  var index = models.indexOf(selectedId);
  var layerLegendURL = legendURL.replace("%LAYER_INFO%", legends[index]);
  var legendEl = document.getElementById('legend');
  legendEl.src = layerLegendURL;
  legendEl.style.display = "block";
}

function hideLegend ()
{
  var legendEl = document.getElementById('legend');
  legendEl.style.display = "none";
}

function showInfo (shownValue) {
  var infoElement = document.getElementById('info');
  infoElement.innerHTML = shownValue;
  infoElement.style.opacity = "1";
}

function showSliderInfo (bShow) {
  var currentTime = new Date();
  var hour = currentTime.getHours();
  var infoSlider = document.getElementById('info_slider');
  var index = models.indexOf(selectedId);
  var setHour = sliderTopRange[index] === 24 ? hour : 0;
  if(setHour.toString().length === 1)
  {
    setHour = "0" + setHour;
  }
  infoSlider.style.opacity = bShow ? "1" : "0";
  if(bShow){
    var slider = document.getElementsByClassName('slider')[0];
    var value = document.getElementsByClassName('value')[0];
    var topRange = sliderTopRange[index];
    slider.max = topRange;
    slider.id = selectedId;
    slider.name = selectedId;
    value.id = selectedId;
    value.innerHTML = getDisplayDate() + ": Hour " + setHour;
    slider.value = setHour;
  } else {
    // set to current hour
    var slider = document.getElementsByClassName('slider')[0];
    slider.value = setHour;
    
  }
}

function selectLayer (targetID) {
	var index = models.indexOf(targetID);
    var targetLayer = layers[index];
    map.addLayer(targetLayer);
    isLayerSelected = true;
    selectedId = targetID;  
    showSliderInfo(true);
}

function deselectCurrentLayer () {
	  var index = models.indexOf(selectedId);
    var layer = layers[index];
    map.removeLayer(layer);
    setSelectedNone();
    hideInfo();
    showSliderInfo(false);
    hideLegend ();
}

function setSelectedNone () {
    isLayerSelected = false;
    selectedId = "";
}

function getIDFromButton (buttonClsList) {
 var targetID = "";
 for (var i = 0; i < buttonClsList.length; i++) {
		var cls = buttonClsList[i];
		if(cls !== "clickable" && cls !== "modelLayer") {
		  targetID = cls;
		}
	}
 return targetID;
}

function hideInfo () {
  var infoElement = document.getElementById('info');
  infoElement.style.opacity = "0";
}

function toggleParamSelectDDCollapse(event) {
    event.currentTarget.classList.toggle("active");
    var collapsedContent = event.currentTarget.nextElementSibling;
    if (collapsedContent.style.maxHeight) {
        collapsedContent.style.maxHeight = null;
    } else {
        collapsedContent.style.maxHeight = collapsedContent.scrollHeight + "px";
    }
}

function toggleSubMenuDDCollapse(event) {
    event.currentTarget.classList.toggle("active");
    var collapsedContent = event.currentTarget.nextElementSibling;
    if (collapsedContent.style.maxHeight) {
        collapsedContent.style.maxHeight = null;
    } else {
    	var additionalHeight = collapsedContent.scrollHeight;
    	// setting nested sub menu entries height
        collapsedContent.style.maxHeight = additionalHeight + "px";
        // adapting the parent (paramSelect dropdown's) height for the calculated additional height
        var parent = collapsedContent.parentElement;
        var height = getElementHeight(parent);
        parent.style.maxHeight = height + additionalHeight + "px";
    }
}

function getElementHeight (element) {
	var elementStyle = element.getAttribute("style");
    var elementHeight = elementStyle.substring(elementStyle.indexOf(":") + 2, elementStyle.indexOf("px"));
    var intHeight = parseInt(elementHeight);
    return intHeight;
}

function setOptions() {
// Highcharts default options
  Highcharts.setOptions({
        lang: {
            thousandsSep: '',
            myKey: "Click to download chart in different formats."
        },
        time: {
            useUTC: false
        },
        chart: {
            zoomType: 'x',
            backgroundColor: '#ffffff',
            plotBackgroundColor: null,
            plotBorderColor: '#CCCCCC',
            plotBorderWidth: 1
        },
        title: {
            style: {
                color: '#1B325F',
                fontWeight: 'bold',
                backgroundColor: '#004A67',
                fontSize: '140%',
                margin: 4
            }
        },
        subtitle: {
            style: {
                color: '#666666',
                fontFamily: 'serif',
                fontSize: '140%'
            }
        },
        legend: {
            enabled: true
        },
        credits: {
            enabled: false,
            text: "©PO-Res. Grp",
            href: "https://www.um.edu.mt/science/geosciences/physicaloceanography"
        },
        xAxis: {
            title: {
                text: 'Time (UTC)',
                style: {
                    fontSize: '130%',
                    fontFamily: '"Times New Roman", serif',
                    fontWeight: 'bold'
                }
            },
            type: 'datetime',
            dateTimeLabelFormats: {
                hour: '%H:%M',
                day: '%e %b %y'
            },
            lineColor: '#FF0000',
            lineWidth: 1,
            gridLineColor: '#CCCCCC', //#197F07',
            gridLineWidth: 1
        },
        yAxis: {
            lineColor: '#FF0000',
            lineWidth: 1,
            gridLineColor: '#CCCCCC', //'#197F07',
            gridLineWidth: 1,
            minorGridLineColor: '#E6E6E6', //'#C5EEFA',
            minorTickInterval: 'auto',
            title: {
                style: {
                    fontSize: '130%',
                    fontFamily: '"Times New Roman", serif',
                    fontWeight: 'bold'
                }
            }
        },
        colors: ['#0010FF', '#008FFF', '#00CFFF', '#50FFAF', '#FFEF00', '#FF7000',
            '#EF0000', '#7CB5EC', '#E60000', '#020FCA', '#00b35f', '#00B33C'
        ]
    });
}


function importScripts () {
  //alert($(location).attr('href'));
  $("head").append($("<script></script>").attr("src", $(location).attr('href') + '/constants.js'));
  $("head").append($("<script></script>").attr("src", $(location).attr('href') + '/atlas.js'));
}
